import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvertisingPlatformInfoForm} from './advertising-platform-info-form';

export class TaboolaInfoForm extends AdvertisingPlatformInfoForm {

  constructor() {
    super();
    this.formGroup = new FormGroup({
      currencyId: new FormControl('', Validators.required),
      clientId: new FormControl('', Validators.required),
      clientSecret: new FormControl('', Validators.required),
      accountId: new FormControl('', Validators.required),
    });
  }

  static override getPlatformName(): string {
    return 'taboola';
  }
}
